import changeSelectedFileProvider from '../actions/changeSelectedFileProvider';
import FilePickerErrorMessageType from '../types/FilePickerErrorMessageType';
import getDefaultFileProvider from '../actions/helpers/getDefaultFileProvider';
import showFilePickerErrorMessage from '../actions/errorMessageActions/showFilePickerErrorMessage';
import { FileProviderViewState } from 'owa-fileprovider-store';
import { getFilePickerStore } from '../store/filePickerStore';
import { shouldHideOneDrive } from './getAddedProviders';

export async function initializeFilePickerViewState(providers: FileProviderViewState[]) {
    const viewState = getFilePickerStore().viewState;
    if (!providers || providers.length === 0) {
        showFilePickerErrorMessage(
            FilePickerErrorMessageType.NoProviders,
            viewState.filePickerErrorMessageViewState
        );
        return;
    }

    const defaultProvider = getDefaultFileProvider(filterForGroupsOnlyOneDriveProvider(providers));
    changeSelectedFileProvider(defaultProvider, viewState);
}

function filterForGroupsOnlyOneDriveProvider(
    providers: FileProviderViewState[]
): FileProviderViewState[] {
    if (!shouldHideOneDrive()) {
        return providers;
    }
    return providers.filter(provider => !!provider.name);
}
